<template>
	<div class="container px-0">
        <content-header :links="header_content">
            <div v-if="selected === 'permissions'" class="col-12 mt-auto mb-0 text-center text-md-right">
                <a href="javascript:void(0)" v-on:click="$refs.add_people_modal.openModal()" class="btn btn-primary px-5">+ Add member</a>
            </div>
        </content-header>
        <div class="row">
            <div class="col-12">
                <company-staff-and-permissions
                    v-if="selected === 'permissions'"
                    :store_url="store_url"
                    :roles="roles"
                    :company_staff="teamData"
                    :loading="loading"
                    :show_user_url="show_user_url"
                    @getData="getData(false)"
                />
                <staff-matrix-table
                    v-if="selected === 'team'"
                    :store_url="store_url"
                    :teamData="teamData"
                    :loading="loading"
                    :is_job="true"
                    :show_user_url="show_user_url"
                />
                <ppe-component
                    v-if="selected === 'ppe'"
                    :team="teamData"
                    :loading="loading"
                    :ppe_types="ppe_types"
                    :is_job="true"
                    :show_user_url="show_user_url"
                    :show_submission_url="show_submission_url"
				/>
                <certificate-component
                    v-if="selected === 'certificates'"
                    :loading="loading"
                    :certificates="teamData"
                    :training_certificate_types="training_certificate_types"
                    :is_job="true"
                    :show_user_url="show_user_url"
                    :show_submission_url="show_submission_url"
				/>
                <toolbox-talks-component
                    v-if="selected === 'toolbox_talks'"
                    :loading="loading"
                    :team="teamData"
                    :toolbox_talks_types="toolbox_talks_types"
                    :is_job="true"
                    :show_user_url="show_user_url"
                    :show_submission_url="show_submission_url"
				/>
            </div>
            <edit-staff-modal
                @parent_method="getData"
                ref="add_people_modal"
                title="Add People"
                :url="add_user_url"
                :edit_user = false
                :company_roles="company_roles"
            ></edit-staff-modal>
        </div>
    </div>
</template>

<script>

	import EditStaffModal from "../modals/EditStaffModal";
	import RoleList from "../people/RoleList";
    import CompanyStaffAndPermissions from "../people/CompanyStaffAndPermissions";
    // import JobPeopleAndRoleListing from "../people/JobPeopleAndRoleListing";
    import StaffMatrixTable from "../people/StaffMatrixTable";
    import PpeComponent from "../operations/PpeComponent"
    import CertificateComponent from "../operations/CertificatesComponent"
    import ToolboxTalksComponent from "../operations/ToolboxTalksComponent"
	export default {
		name: "JobPeoplePage",
		components: {CompanyStaffAndPermissions, RoleList, EditStaffModal, PpeComponent, CertificateComponent, ToolboxTalksComponent, StaffMatrixTable},
		props: [
        	'job',
            'get_data_url',
            'roles',
            'add_user_url',
            'show_user_url',
            'header_content',
            'store_url',
            'company_roles',
            'selected',
            'ppe_types',
            'training_certificate_types',
            'toolbox_talks_types',
            'show_submission_url',
        ],

        data(){
			return {
                loading:true,
                teamData:null,
            }
        },

        mounted() {
            console.log(this);
            this.getData()
        },


        methods: {
			formatRoleName(role_name){
				let names = role_name.split('_');
				for (let i = 0; i < names.length; i++){
					names[i] =  names[i].charAt(0).toUpperCase() + names[i].slice(1);
                }

				return names.join(' ');
            },
            getData(show_loader = true){
                    let _this = this;
                    if(show_loader === true){
                        _this.loading = true;
                    }
                    axios.get(_this.get_data_url)
                        .then(function (response){
                            _this.loading = false;
                            _this.teamData = response.data;
                        });
                },
        }
	}
</script>
